<script lang="ts">
  import '@nrk/nrk-sans/nrk-sans.css';
  import './global.css';
  import './utils/router';
  import { Router } from 'sv-router';
</script>

<Router base="#" />
